import type { UserService } from '../../user'
import type { GeoLocationService } from '../../geo-location'
import type { BrowserService } from '../../browser'
import { Experiment } from '@grammarly/experimentation-js-sdk'
import { clientExperimentsConfig } from './client-experiments'

export interface ExperimentContext {
  userService: UserService
  geoLocationService: GeoLocationService
  browserService: BrowserService
  pageSlug: string
}

export type ClientExperimentConfig = {
  experimentId: string
  variants: readonly string[]
  eligibility: (ctx: ExperimentContext) => boolean
}

function createClientExperiments<T extends Record<string, ClientExperimentConfig>>(config: T) {
  const experiments: Record<string, { experiment: Experiment; eligibility: (ctx: ExperimentContext) => boolean }> = {}

  for (const key in config) {
    const { experimentId, variants, eligibility } = config[key]
    experiments[key] = {
      experiment: new Experiment(experimentId, [...variants]),
      eligibility,
    }
  }

  return experiments as {
    [K in keyof T]: {
      experiment: Experiment<T[K]['variants'][number]>
      eligibility: T[K]['eligibility']
    }
  }
}

export const ClientAssignedExperiments = createClientExperiments(clientExperimentsConfig)
